/**
 * RootState namespaces
 */
export enum Namespace {
    APP = 'ROUTER_CHANGE/APP',
}

export enum QueryParam {
    BASKET = 'vfBasket',
    TARGET_URL = 'targetURL',
    TARGET = 'target'
}

export enum VFCookie {
    MDDKEKS = 'MDDKeks',
}

export enum Domains {
    VF = 'https://eweb8.vfd2-testnet.de',
    ZUHAUSEPLUS = 'https://zuhauseplus.vodafone.de',
}

export enum Endpoints {
    LOGIN_REDIRECT = '/api/login/',
    JARVIS = '/api/jarvis/v1/getRouterChangeProducts/'
}

export enum JarvisPriceType {
    ONCE = 'once',
    MONTHLY = 'monthly',
    STAIRWAY = 'stairway'
}

export enum FeeText {
    ROUTER_DELIVERY_FEE = 'Lieferpauschale',
    PROVISION_FEE = 'Bereitstellungsentgelt',
}
